import type { ParticipantCoverageMetricRow } from "../services/dataCoverageService";

export const COMMON_FITBIT_HEALTHKIT_METRIC_KEYS = [
  "steps",
  "calories",
  "distance",
  "restingHeartRate",
  "sleepDuration",
  "sleepStages",
  "weight",
  "bodyFat",
  "bmi",
  "breathingRate",
  "vo2Max",
  "oxygenSaturationAvg",
  "foodLog",
] as const;

const COMMON_FITBIT_HEALTHKIT_METRIC_KEY_SET = new Set<string>(
  COMMON_FITBIT_HEALTHKIT_METRIC_KEYS,
);

export function isCommonFitbitHealthKitMetric(metricKey: string): boolean {
  return COMMON_FITBIT_HEALTHKIT_METRIC_KEY_SET.has(metricKey);
}

export function filterCommonFitbitHealthKitMetrics(
  rows: ParticipantCoverageMetricRow[],
): ParticipantCoverageMetricRow[] {
  return rows.filter((row) => isCommonFitbitHealthKitMetric(row.metricKey));
}
